<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true" class="personal-visit-details-dialog">
  <sc-dialog-title>
    {{ 'Besucher bearbeiten' | translate: [titleDictionaryKey, translationService.language]}}
  </sc-dialog-title>

  <sc-flex-fitting-content [vertical]="true" class="no-field-space">
    <sc-master-detail [data]="listEntries" [readOnly]="true" [selection]="[selectedEntry]"
      (selectionChanged)="handleSelectionChange($event)">
      <sc-padding [fitHeight]="true">
        <sc-scroll-pane>
          <app-visit-masterdata [visit]="visit" *ngIf="selectedIndex===0" [types]="types"
            [upfrontRegistration]="upfrontRegistration"
            (masterdataValidityChanged)="onMasterdataValidityChanged($event)"
            (openMandatoryTasksChanged)="onOpenTasksChanged($event)" [inEditMode]="inEditMode"
            [registerArrival]="visit.registerEntrance">
          </app-visit-masterdata>

          <app-visit-visited [visit]="visit" *ngIf="selectedIndex===1"></app-visit-visited>

          <app-visit-group [visit]="visit" *ngIf="selectedIndex===2"></app-visit-group>

          <app-visit-tasks [visit]="visit" [upfrontRegistration]="upfrontRegistration" *ngIf="selectedIndex===3"
            (openMandatoryTasksChanged)="onOpenTasksChanged($event)"></app-visit-tasks>

          <app-visit-log [visit]="visit" *ngIf="selectedIndex===4"></app-visit-log>
        </sc-scroll-pane>
      </sc-padding>
    </sc-master-detail>
  </sc-flex-fitting-content>

  <form [formGroup]="formGroup">

    <div class="tasks-hint" *ngIf="hasMandatoryOpenTasks">
      <sc-flex>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-dictionary-label dictionaryKey="tmc-visit.ui.visit.open-tasks-hint"></sc-dictionary-label>
      </sc-flex>
    </div>
    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
    <sc-actionbar>

      <sc-content-spacer [grow]="true"></sc-content-spacer>

      <ng-container *ngIf="showRegisterEntrance">
        <sc-checkbox-field formControlName="registerEntrance" [label]="'Ankunft buchen' | translate: ['tmc.visit.action.register-entrance',
        translationService.language]"></sc-checkbox-field>
        <sc-content-spacer></sc-content-spacer>
      </ng-container>

      <button mat-stroked-button mat-dialog-close>
        {{'close' | translate: ['tmc.visit.action.close', translationService.language]}}
      </button>

      <ng-container *ngIf="!readOnly">
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="save()" [disabled]="!masterdataValid || this.hasMandatoryOpenTasks">
          {{'save' | translate: ['tmc.visit.action.save', translationService.language]}}</button>
      </ng-container>
    </sc-actionbar>
  </form>
</sc-flex>
